<template>
	<div class="data-apply">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/datacenter/dclist' }">食材</el-breadcrumb-item>
			<el-breadcrumb-item>编辑适用信息</el-breadcrumb-item>
		</el-breadcrumb>
		<el-row style="margin-top:15px">
			<el-col style="width:200px;">
				<el-image
				 style="width: 200px; height: 150px;border: 1px solid #cccccc;border-radius: 6px;"
				 :src="ingredientExt.ingredientsImageUrl"
				 fit="cover"
				></el-image>
			</el-col>
			<el-col
			 :span="16"
			 style="padding-left:30px;text-align:left"
			>
				<span>食材名称：{{ingredientExt.ingredientsName}}</span>
				<el-divider></el-divider>
				<el-form
				 ref="form"
				 label-width="60px"
				>
					<el-form-item
					 label="常用性："
					 style="maring-bottom:10px"
					>
						<div style="width: 145px;">
							<el-switch
								v-model="ingredientExt.commonlyUsedFlag"
								:active-value="1"
								:inactive-value="0"
								active-color="#13ce66">
							</el-switch>
							<span class="_tips">{{ingredientExt.commonlyUsedFlag==1?'常用':'不常用'}}</span>
						</div>
					</el-form-item>
					<el-form-item label="清真：">
						<div style="width: 145px;">
							<el-switch
								v-model="ingredientExt.halalFlag"
								:active-value="1"
								:inactive-value="0"
								active-color="#13ce66">
							</el-switch>
							<span class="_tips">{{ingredientExt.halalFlag==1?'清真':'非清真'}}</span>
						</div>
						</el-switch>
					</el-form-item>
				</el-form>
				<el-divider></el-divider>
				<span style="display: block;margin-bottom: 15px;text-align:left;">季节适应性</span>
				<div style="margin-left:6%">
					<el-row>
						<el-col class="seasons">
							<span style="float: left;">春季</span>
							<span> 3月</span>
						</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="springMarch"
							 v-model="springMarch"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'springMarch',3,march.id)"
							 :marks="marks"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">4月</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="springApril"
							 v-model="springApril"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'springApril',4,april.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">5月</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="springMay"
							 v-model="springMay"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'springMay',5,may.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">
							<span style="float: left;">夏季</span>
							<span> 6月</span>
						</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="summerJune"
							 v-model="summerJune"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'summerJune',6,june.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">7月</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="summerJuly"
							 v-model="summerJuly"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'summerJuly',7,july.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">8月</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="summerAug"
							 v-model="summerAug"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'summerAug',8,aug.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">
							<span style="float: left;">秋季</span>
							<span> 9月</span>
						</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="autumnSep"
							 v-model="autumnSep"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'autumnSep',9,sep.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">10月</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="autumnOct"
							 v-model="autumnOct"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'autumnOct',10,oct.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">11月</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="autumnNove"
							 v-model="autumnNove"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'autumnNove',11,nove.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">
							<span style="float: left;">冬季</span>
							<span> 12月</span>
						</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="winterDec"
							 v-model="winterDec"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'winterDec',12,dec.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">1月</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="winterJan"
							 v-model="winterJan"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'winterJan',1,jan.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="seasons">2月</el-col>
						<el-col
						 :span="20"
						 class="slider-container"
						>
							<el-slider
							 ref="winterFeb"
							 v-model="winterFeb"
							 :step="14"
							 :max="84"
							 @input="(nval)=>dragVal(nval,'winterFeb',2,feb.id)"
							 :format-tooltip="formatTooltip"
							>
							</el-slider>
						</el-col>
					</el-row>
				</div>
				<apply-area
				 :data="ingredientExt.area"
				 @areaChange="areaChange"
				></apply-area>
				<el-divider></el-divider>
				<pick-tags label="适宜人群" labelWidth="60px" :dynamicTags="ingredientExt.crowd" :tags="crowdList" :required="false"></pick-tags>
				<el-divider></el-divider>
				<pick-tags label="功效作用" labelWidth="60px" :dynamicTags="ingredientExt.efficacy" :tags="efficacyList" :required="false"></pick-tags>
				<el-divider></el-divider>
				<div>
					<el-form label-width="60px">
						<el-form-item label="适宜搭配">
							<el-select
							 style="width:90%"
							 v-model="suitable"
							 multiple
							 filterable
							 remote
							 placeholder="请输入关键词"
							 :remote-method="remoteMethod"
							 @change="changeMatches"
							 @remove-tag="removeMatches"
							 :loading="loading"
							>
								<el-option
								 v-for="item in ingredientList"
								 :key="item.relateId"
								 :label="item.relateName"
								 :value="item.relateId"
								>
								</el-option>
							</el-select>
						</el-form-item>
						<el-divider></el-divider>
						<el-form-item label="不宜同食">
							<el-row
							 v-for="(item, index) in ingredientExt.notSuitable"
							 :key="index"
							 style="font-size: 12px;"
							>
								<el-col
								 :span="4"
								 style="text-align:left;"
								>
									{{item.relateName}}
								</el-col>
								<el-col :span="16">
									{{item.remark}}
								</el-col>
								<el-col
								 :span="2"
								 style="text-align:center"
								>
									<a
									 class="el-link--default"
									 style="font-size: 12px;color:blue"
									 @click="delNotSuitable(item,index)"
									><span class="el-link--inner">删除</span></a>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="4">
									<el-autocomplete
										v-model="notsuitable"
										:fetch-suggestions="querySearchAsync"
										placeholder="搜索食材"
										clearable
										@select="(item)=>handleSelect(item,'not_suitable')"
                	></el-autocomplete>
								</el-col>
								<el-col :span="16">
									<el-input v-model="reject.remark" placeholder="原因" type="text" show-word-limit maxlength="100"></el-input>
								</el-col>
								<el-col
								 :span="2"
								 style="text-align:center"
								>
									<a
									 class="el-link--default"
									 style="font-size: 12px;color:blue"
									 @click="saveNotSuitable"
									><span class="el-link--inner">保存</span></a>
								</el-col>
							</el-row>
						</el-form-item>
						<el-divider></el-divider>
						<el-form-item label="相近食材">
							<el-row
							 v-for="(item, index) in ingredientExt.replaceable"
							 :key="index"
							 style="font-size: 12px;"
							>
								<el-col
								 :span="4"
								 style="text-align:left;"
								>
									{{item.relateName}}
								</el-col>
								<el-col :span="16">
								</el-col>
								<el-col
								 :span="2"
								 style="text-align:center"
								>
									<a
									 class="el-link--default"
									 style="font-size: 12px;color:blue"
									 @click="delReplaceable(item,index)"
									><span class="el-link--inner">删除</span></a>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="4">
									<el-autocomplete
										v-model="replaceable"
										:fetch-suggestions="querySearchAsync"
										placeholder="搜索食材"
										clearable
										@select="(item)=>handleSelect(item,'replaceable')"
                	></el-autocomplete>
								</el-col>
								<el-col :span="16">
								</el-col>
								<el-col>
								</el-col>
							</el-row>
						</el-form-item>
					</el-form>
				</div>
			</el-col>
		</el-row>
		<el-row style="position: fixed;bottom:3px;padding-left:35%">
			<el-button type="primary" @click="onSubmit">保存</el-button>
    	<el-button @click="cancle">取消</el-button>
		</el-row>
	</div>
</template>

<script>
import {fetchExtAreaGroupList} from '@/api/city'
import { fetchDictListByType } from '@/api/dict'
import { queryByKeyWord,updateExt,queryIngredientDetail } from '@/api/catering/ingredient'
import ApplyArea from "../applyarea";
import PickTags from "@/components/PickTags/index";
export default {
  components: {
    ApplyArea,
    PickTags
  },
  data() {
    return {
      springMarch: 0,
      springApril: 0,
      springMay: 0,
      summerJune: 0,
      summerJuly: 0,
      summerAug: 0,
      autumnSep: 0,
      autumnOct: 0,
      autumnNove: 0,
      winterDec: 0,
      winterJan: 0,
      winterFeb: 0,
			march: {},
			april: {},
      may: {},
      june: {},
      july: {},
      aug: {},
      sep: {},
      oct: {},
      nove: {},
      dec: {},
      jan: {},
      feb: {},
      marks: {
        8: "不吃",
        22: "一月一次",
        36: "两周一次",
        50: "每周一次",
        64: "每周两次",
        78: {
          label: "每日一次",
          style: {
            width: "70px",
            textAlign: "right"
          }
        }
      },
      loading: false,
			suitable: null,
			notsuitable: null,
			reject: {},
			replaceable: null,
			ingredientList:[],
			efficacyList:[],
			crowdList: [],
			ingredientExt: {
				commonlyUsedFlag: 1,
				halalFlag: 1,
				allExt: [],
				allExtRelate: [],
				season: [],
				suitable: [],
				notSuitable: [],
				replaceable: [],
				crowd: [],
				efficacy: [],
				area: {}
			}
    };
  },
	created() {
		this.query(this.$route.query.uid);
	},
  methods: {
		query(id) {
			queryIngredientDetail(id).then(response=>{
				let data = response.data;
				this.ingredientExt = data;
				if(Object.keys(data.area).length > 0) {
					if(data.suitable.length > 0) {
						this.ingredientList = data.suitable;
						data.suitable.map(item=>{
							this.suitable.push(item.relateId);
						})
					}
					if(data.season.length > 0) {
						this.assemblySeason(data.season);
					}
				} else {
					this.fetchAreaList();
				}
				this.queryDictListByCode('efficacy');
				this.queryDictListByCode('crowd');
			})
		},
		assemblySeason(data) {
			data.map(item=>{
				const month = item.itemDictValue;
				let feacy = item.valueDictValue == null? -1: item.valueDictValue;
				let dom = '';
				if(month==3) {
					dom = 'springMarch';
					this.springMarch = (feacy+1)*14
				}	
				if(month==4) {
					dom = 'springApril';
					this.springApril = (feacy+1)*14
				}	
				if(month==5) {
					dom = 'springMay';
					this.springMay = (feacy+1)*14
				}	
				if(month==6) {
					dom = 'summerJune';
					this.summerJune = (feacy+1)*14
				}	
				if(month==7) {
					dom = 'summerJuly';
					this.summerJuly = (feacy+1)*14
				}	
				if(month==8) {
					dom = 'summerAug';
					this.summerAug = (feacy+1)*14
				}	
				if(month==9) {
					dom = 'autumnSep';
					this.autumnSep = (feacy+1)*14
				}	
				if(month==10) {
					dom = 'autumnOct';
					this.autumnOct = (feacy+1)*14
				}	
				if(month==11) {
					dom = 'autumnNove';
					this.autumnNove = (feacy+1)*14
				}	
				if(month==12) {
					dom = 'winterDec';
					this.winterDec = (feacy+1)*14
				}	
				if(month==1) {
					dom = 'winterJan';
					this.winterJan = (feacy+1)*14
				}	
				if(month==2) {
					dom = 'winterFeb';
					this.winterFeb = (feacy+1)*14
				}				
				this.dragVal((feacy+1)*14,dom,month,item.id);
			})
		},
		onSubmit() {
			this.ingredientExt.season = [];
			this.ingredientExt.season.push(this.march);
			this.ingredientExt.season.push(this.april);
			this.ingredientExt.season.push(this.may);
			this.ingredientExt.season.push(this.june);
			this.ingredientExt.season.push(this.july);
			this.ingredientExt.season.push(this.aug);
			this.ingredientExt.season.push(this.sep);
			this.ingredientExt.season.push(this.oct);
			this.ingredientExt.season.push(this.nove);
			this.ingredientExt.season.push(this.dec);
			this.ingredientExt.season.push(this.jan);
			this.ingredientExt.season.push(this.feb);
			if(!this.ingredientExt.id) {
				Object.assign(this.ingredientExt,{id: this.$route.query.uid})
			}
			console.log(this.ingredientExt);
			// return;
			const loading = this.$loading({
				lock: true,
				text: '食材适用信息保存中,请不要退出',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			updateExt(this.ingredientExt).then(response=>{
				this.$message.success('食材适用信息编辑成功');
				loading.close();
				this.cancle();
			})
		},
		cancle() {
			this.$router.push({name:'datalist',path: '/datacenter/dclist',params: {page: this.$route.query.page}});
		},
    dragVal(nval, dom,month,id) {
      let color = null;
			let valueDictValue = null;
			let valueDictName = null;
      if (nval > 0 && nval <= 14) {
        color = "#919191";
				valueDictValue = 0;
				valueDictName = '不吃'
      } else if (nval > 14 && nval <= 28) {
        color = "#73d13d";
				valueDictValue = 1;
				valueDictName = '一月一次'
      } else if (nval > 28 && nval <= 42) {
        color = "#fcca00";
				valueDictValue = 2;
				valueDictName = '两周一次'
      } else if (nval > 42 && nval <= 56) {
        color = "#ff9502";
				valueDictValue = 3;
				valueDictName = '每周一次'
      } else if (nval > 56 && nval <= 70) {
        color = "#ff3d00";
				valueDictValue = 4;
				valueDictName = '每周两次'
      } else if (nval > 70) {
        color = "#cf1322";
				valueDictValue = 5;
				valueDictName = '每日一次'
      }
			if(!id) {
				id = null;
			}
			let obj = {
					id: id,
					itemDictCode: "season",
					itemDictName: month + '月',
					itemDictValue: month,
					valueDictCode: "season_number",
					valueDictName: valueDictName,
					valueDictValue: valueDictValue,
			}
			if(month == 3) {
				this.march = obj;
			}
			if(month == 4) {
				this.april = obj;
			}
			if(month == 5) {
				this.may = obj;
			}
			if(month == 6) {
				this.june = obj;
			}
			if(month == 7) {
				this.july = obj;
			}
			if(month == 8) {
				this.aug = obj;
			}
			if(month == 9) {
				this.sep = obj;
			}
			if(month == 10) {
				this.oct = obj;
			}
			if(month == 11) {
				this.nove = obj;
			}
			if(month == 12) {
				this.dec = obj;
			}
			if(month == 1) {
				this.jan = obj;
			}
			if(month == 2) {
				this.feb = obj;
			}
			
      this.$refs[dom].$el.getElementsByClassName(
        "el-slider__bar"
      )[0].style.backgroundColor = color;
    },
    formatTooltip(val) {
      if (val > 0 && val <= 14) {
        return "不吃";
      } else if (val > 14 && val <= 28) {
        return "一月一次";
      } else if (val > 28 && val <= 42) {
        return "两周一次";
      } else if (val > 42 && val <= 56) {
        return "每周一次";
      } else if (val > 56 && val <= 70) {
        return "两周两次";
      } else if (val > 70) {
        return "每日一次";
      }
    },
		fetchAreaList() {
			fetchExtAreaGroupList().then(response=>{
				this.ingredientExt.area = response.data;
			})
		},
		queryDictListByCode(code) {
			fetchDictListByType(code).then(res=>{
				let data = res.data.map(item=>{
					let id = null;
					if(code == 'crowd') {
						if(this.ingredientExt.crowd.length > 0) {
							this.ingredientExt.crowd.map(c=>{
								if(item.value == c.itemDictValue) {
									id = c.id;
									c.name = item.name;
									c.index = item.index;
								}
							})
						}
					} else {
						if(this.ingredientExt.efficacy.length > 0) {
							this.ingredientExt.efficacy.map(c=>{
								if(item.value == c.itemDictValue) {
									id = c.id;
									c.name = item.name;
									c.index = item.index;
								}
							})
						}
					}
						return {id: id,name: item.name,itemDictCode: item.code,itemDictName:item.name,
										itemDictValue:item.value,valueDictCode:'suitable',valueDictName:'适宜',valueDictValue:1,index:item.index}
				})
				if(code == 'crowd') {
					this.crowdList = data;
				} else {
					this.efficacyList = data;
				}
			})
		},
    areaChange(nval,city) {
			if(nval == 1) {
				city.valueDictName = '常用'
			} else {
				city.valueDictName = '不常用'
			}
		},
    remoteMethod(query) {
			if(query){
				queryByKeyWord({keyWord:query}).then(response=>{
					if(response.data) {
						let data = response.data.map(item=>{
							return {relateId: item.id,relateImage:item.ingredientsImage,relateName:item.ingredientsName,relateType: 'suitable'}
						})
						this.ingredientList = data;
					}
				})
			}
		},
    changeMatches(nval) {
			let size = this.suitable.length;
			if(size > 30) {
				this.$message.warning("适宜搭配食材最多只能选择30个");
				this.ingredientExt.suitable.splice(size-1,1);
				return;
			}
			this.ingredientExt.suitable = [];
			this.ingredientList.map(item=>{
				nval.map(array=>{
					if(item.relateId == array) {
						this.ingredientExt.suitable.push(item);
					}
				})
			})
		},
		removeMatches(tag) {
			this.ingredientExt.suitable = this.ingredientExt.suitable.filter(item=>{
				return item.relateId != tag;
			})
		},
		querySearchAsync(queryString, cb) {
			if(queryString) {
				queryByKeyWord({keyWord:queryString}).then(response=>{
					let result = response.data.map(item=>{
						return {value: item.ingredientsName,relateId:item.id,relateImage:item.ingredientsImage,relateName:item.ingredientsName,remark:null}
					})
					cb(result)
				})
			}
    },
		handleSelect(item,type) {
			if(type == 'replaceable') {
				item.relateType = type;
				this.ingredientExt.replaceable.push(item);
				this.replaceable = null;
			} else {
				this.reject = item;
				this.reject.relateType = type;
			}
		},
		saveNotSuitable() {
			if(this.reject.relateId) {
				this.ingredientExt.notSuitable.push(this.reject);
				this.reject = {};	
				this.notsuitable = null;
			}
		},
    delNotSuitable(item,index) {
      this.ingredientExt.notSuitable.splice(index, 1);
		},
		delReplaceable(item,index) {
			this.ingredientExt.replaceable.splice(index, 1);
		}
  }
};
</script>

<style lang="scss" scoped>
.data-apply {
  margin-top: 15px;
  margin-left: 15px;
  padding-bottom: 30px;
  position: relative;
}
.seasons {
  width: 70px;
  line-height: 18px;
  // padding-left: 45px;
  // margin-right: 25px;
  text-align: right;
}
.slider-container {
  padding-left: 25px;
}
._tips {
	display: inline-block;
	font-size: 12px;
	color: #a8a8a8;
}
</style>



// WEBPACK FOOTER //
// src/views/datacenter/components/basedata/ingredient/applyinfo.vue